import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaHeart, FaHandHoldingHeart, FaDonate } from "react-icons/fa";

const GauSeva = () => {
  const sections = [
    {
      title: "Gau Mata: Shrishti ka Aadhaar",
      text: "Hamare shastron mein kaha gaya hai 'Gavo Vishwasya Matarah'—yani Gau Mata vishwa ki mata hain. Maharaj Ji ke maargdarshan mein, Anant Sewa Ashram ne hazaron nirashrit gaayon ko ek surakshit aur mamta bhara ghar diya hai. Hamari Gaushala sirf ek sthan nahi, balki ek mandir hai jahan har din seva se punyamaya vatavaran banta hai.",
      image:
        "https://images.unsplash.com/photo-1541443131876-44b03de101c5?q=80&w=2000",
      reverse: false,
    },
    {
      title: "Vrindavan ki Parampara: Karuna ka Maarg",
      text: "Lord Krishna ne swayam Gau-seva karke hamein ye sikhaya ki jeev-matra ki seva hi param-dharma hai. Aaj ke is yug mein, jab khet aur charagah khatam ho rahe hain, hamari zimmedari aur bhi badh jati hai. Hum shuddh hara chara, thanda paani aur chikitsa suvidhaon dwara unki har zaroorat ka dhyan rakhte hain.",
      image:
        "https://images.unsplash.com/photo-1596733430284-f7437764b1a9?q=80&w=2000",
      reverse: true,
    },
    {
      title: "Aapka Chhota Sa Sahyog, Unka Jeevan",
      text: "Gau-seva se na sirf hamare paap kat-te hain, balki hamein mansik shanti aur samridhi milti hai. Aapka daan kisi bimar gaay ki dawa ban sakta hai ya kisi nanhne bachhde ka pet bhar sakta hai. Is punya karya se judein aur Maharaj ji ke 'Gau-Sanrakshan' mission ko poora karne mein hamara saath dein.",
      image:
        "https://unsplash.com/photos/herd-of-cattle-standing-on-green-grass-qZPEd8LO1Sg",
      reverse: false,
    },
  ];

  return (
    <div style={{ backgroundColor: "#fffaf5" }}>
      {/* Hero Section */}
      <div
        className="hero-banner d-flex align-items-center justify-content-center text-center text-white"
        style={{
          height: "60vh",
          background:
            'linear-gradient(rgba(67, 20, 7, 0.7), rgba(67, 20, 7, 0.7)), url("https://images.unsplash.com/photo-1570051008600-b34bcc51df52?q=80&w=2000") center/cover fixed',
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h1 className="display-3 font-serif mb-3">
            Gau Seva Hi Param Dharma
          </h1>
          <p className="lead tracking-widest text-warning text-uppercase">
            Compassion in Action
          </p>
        </motion.div>
      </div>

      <Container className="py-5">
        {sections.map((section, index) => (
          <Row
            key={index}
            className={`align-items-center mb-5 pb-5 ${section.reverse ? "flex-row-reverse" : ""}`}
          >
            {/* Text Column */}
            <Col lg={6} className="px-lg-5">
              <motion.div
                initial={{ opacity: 0, x: section.reverse ? 50 : -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
              >
                <h2
                  className="display-6 font-serif mb-4"
                  style={{ color: "#431407" }}
                >
                  {section.title}
                </h2>
                <div
                  className="bg-warning mb-4"
                  style={{ height: "3px", width: "60px" }}
                ></div>
                <p
                  className="text-muted fs-5 leading-relaxed"
                  style={{ textAlign: "justify", lineHeight: "1.8" }}
                >
                  {section.text}
                </p>
              </motion.div>
            </Col>

            {/* Image Column */}
            <Col lg={6}>
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
                className="position-relative"
              >
                <div className="p-2 border border-warning rounded-4 overflow-hidden shadow-2xl">
                  <img
                    src={section.image}
                    alt="Gau Seva"
                    className="w-100 rounded-3 shadow"
                    style={{ height: "400px", objectFit: "cover" }}
                  />
                </div>
                {/* Accent icon overlay */}
                <div
                  className="position-absolute bg-warning text-white p-3 rounded-circle shadow"
                  style={{
                    bottom: "-20px",
                    [section.reverse ? "left" : "right"]: "20px",
                  }}
                >
                  <FaHeart size={24} />
                </div>
              </motion.div>
            </Col>
          </Row>
        ))}

        {/* Donation CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="bg-white p-5 text-center shadow-lg rounded-5 border border-warning-subtle mt-5"
          style={{ borderTop: "8px solid #431407" }}
        >
          <h2 className="font-serif mb-4" style={{ color: "#431407" }}>
            Aaj hi Seva ka Sankalp Lein
          </h2>
          <Row className="justify-content-center gap-3 mb-5">
            <Col
              md={3}
              className="p-4 border rounded bg-light hover-shadow transition"
            >
              <h4 className="text-warning">₹501</h4>
              <p className="small text-muted mb-0">Ek din ka chara</p>
            </Col>
            <Col
              md={3}
              className="p-4 border rounded bg-light hover-shadow transition"
            >
              <h4 className="text-warning">₹2,100</h4>
              <p className="small text-muted mb-0">Chikitsa aur Swasthya</p>
            </Col>
            <Col
              md={3}
              className="p-4 border rounded bg-light hover-shadow transition"
            >
              <h4 className="text-warning">₹5,000</h4>
              <p className="small text-muted mb-0">Sampurna Maasik Seva</p>
            </Col>
          </Row>
          <Button
            size="lg"
            className="px-5 py-3 border-0 rounded-pill shadow"
            style={{ backgroundColor: "#431407" }}
          >
            <FaDonate className="me-2" /> ABHI DAAN KAREIN
          </Button>
        </motion.div>
      </Container>

      <style>{`
        .hover-shadow:hover {
          transform: translateY(-5px);
          border-color: #DAA520 !important;
          box-shadow: 0 10px 20px rgba(0,0,0,0.1);
          transition: 0.3s ease;
          cursor: pointer;
        }
      `}</style>
    </div>
  );
};

export default GauSeva;
